import styles from "./SwapGraphInfo.module.css"

const SwapGraphInfo = () => {
  return (
      <div className={styles.graph_info_container}>
          <div className={styles.background}>
          
          <div className={styles.top_row}>

              <div className={styles.spot_price}>
                  <span>Spot Price</span>
                  <span>0.6969 ETH per AMBI</span>
              </div>

              <div className={styles.slippage_tolerance}>
                  <span>Slippage Tolerance</span>
                  <span>5%</span>
              </div>
          </div>



          <div className={styles.bottom_row}>

              <div className={styles.price_limit}>
                  <span>Price Limit after Slippage and Fee</span>
                  <span>0.6861 ETH per AMBI</span>
              </div>

              <div className={styles.provider_fee}>
                  <span>Liquidity Provider Fee</span>
                  <span>0.3%</span>
              </div>
          </div>
          </div>
    </div>
  )
}

export default SwapGraphInfo